import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
import { Icons, Icon } from "../icon";
export var HeightVariant;
(function (HeightVariant) {
    HeightVariant["PrimaryCard"] = "PrimaryCard";
    HeightVariant["Shorts"] = "Shorts";
    HeightVariant["Shows"] = "Shows";
    HeightVariant["Search"] = "Search";
    HeightVariant["Taxonomy"] = "Taxonomy";
    HeightVariant["HideTaxonomy"] = "HideTaxonomy";
    HeightVariant["TaxonomyHero"] = "TaxonomyHero";
    HeightVariant["MindBlown"] = "MindBlown";
    HeightVariant["Premium"] = "Premium";
    HeightVariant["Player"] = "Player";
    HeightVariant["TopShows"] = "TopShows";
    HeightVariant["MastHead"] = "MastHead";
})(HeightVariant || (HeightVariant = {}));
const getStyles = (variant) => {
    switch (variant) {
        case "PrimaryCard":
            return styles.primaryCard;
        case "Shorts":
            return styles.shorts;
        case "Shows":
            return styles.shows;
        case "Search":
            return styles.search;
        case "Taxonomy":
            return styles.taxonomy;
        case "HideTaxonomy":
            return styles.hideTaxonomy;
        case "TaxonomyHero":
            return styles.taxonomyHero;
        case "MindBlown":
            return styles.MindBlown;
        case "Premium":
            return styles.Premium;
        case "Player":
            return styles.Player;
        case "TopShows":
            return styles.topshows;
        case "MastHead":
            return styles.mastHead;
        default:
            return null;
    }
};
export const PlaceholderImage = ({ variant }) => {
    return (React.createElement("div", { className: cn(styles.placeholder, getStyles(variant)) },
        React.createElement(Icon, { type: Icons.DplusPlaceHolder, className: styles.image })));
};

